import axios, { CancelTokenSource } from 'axios';
import API from '../index';
import { Order, Shipment } from '../../types/common';
import { convertItems, convertAddress, convertParcelsToBoxes } from './utils';
import { getCourier } from '../../utils/helpers';
import { getParcelsActualWeight } from '../../containers/Packages/utils';

let cancelToken: CancelTokenSource;

const createOrder = async ({
  originCountry,
  destinationCountry,
  originAddress,
  destinationAddress,
  holdAtLocation,
  parcels,
  type,
  items,
  service,
  itemType,
  incoterm,
}: Shipment): Promise<Order> => {
  if (cancelToken !== undefined) {
    // cancel previous quotation request if any
    cancelToken.cancel();
  }

  cancelToken = axios.CancelToken.source();

  const courier = getCourier(service);
  const boxes = convertParcelsToBoxes(parcels);
  const totalWeight = getParcelsActualWeight(parcels);
  const itemsData = convertItems(type, items);
  const fromAddress = convertAddress(originAddress, originCountry, holdAtLocation?.locationId);
  const toAddress = convertAddress(
    destinationAddress,
    destinationCountry,
    holdAtLocation?.locationId,
  );

  const orders: Record<string, unknown> = {
    fromCountry: originCountry,
    fromAddress,
    toCountry: destinationCountry,
    toAddress,
    itemType,
    carrier: courier,
    service,
    boxes,
    totalWeight,
    itemsData,
    shipmentType: type,
    incoterm,
  };

  if (holdAtLocation?.locationId) {
    orders.halLocationId = holdAtLocation.locationId;
  }
  const data: Order = await API.post('/orders', orders, { cancelToken: cancelToken.token });

  return data;
};

export default createOrder;
